<template>
  <div class="base-table">
    <div :class="['table-wrapper', showPointer ? 'cursor-pointer' : null]">
      <vxe-table
        ref="table"
        :data="data"
        :stripe="stripe"
        :column-config="{ resizable: true }"
        show-overflow="ellipsis"
        :row-config="rowConfig"
        highlight-hover-row
        height="auto"
        size="small"
        auto-resize
        border
        v-ps="'.vxe-table--main-wrapper .vxe-table--body-wrapper'"
        v-bind="$attrs"
        v-on="$listeners"
      >
        <slot></slot>
      </vxe-table>
    </div>
    <slot name="footer"></slot>
    <div class="pagination-wrapper" v-if="pageInfo">
      <el-pagination
        class="table-pagination"
        background
        layout="prev, pager, next, jumper, sizes"
        :total="pageInfo.total"
        :current-page.sync="pageInfo.currentPage"
        :page-size.sync="pageInfo.pageSize"
        :page-sizes="[20, 50, 100]"
        @current-change="pageChange"
        @size-change="sizeChange"
      ></el-pagination>
      <el-tooltip
        :disabled="showTotal !== '9999+'"
        effect="dark"
        content="查看全部"
        placement="top-start"
      >
        <div class="total" :class="{ pointer: showTotal === '9999+' }" @click="getRealTotal">
          {{ "共 " + showTotal + " 条" }}
        </div>
      </el-tooltip>
      <base-dropdown
        v-if="showLineHeightBox"
        ref="levelDropdown"
        width="150"
        placement="top-start"
        class="pointer"
      >
        <template #reference>
          <div class="change-size">
            <svg-icon :icon-class="'line-height-' + lineHeightLevel"></svg-icon>
          </div>
        </template>
        <div
          v-for="i in 3"
          :key="i"
          @click="setLineHeightLevel(i)"
          :class="['command-wrap', 'pointer', { 'is-active': lineHeightLevel == i }]"
        >
          <svg-icon :icon-class="'line-height-' + i"></svg-icon>
          {{ ["紧凑", "舒适", "宽敞"][i - 1] }}
        </div>
      </base-dropdown>
    </div>
  </div>
</template>

<script>
import BaseDropdown from "@/components/UIComponents/Dropdown"
export default {
  name: "new-table",
  components: { BaseDropdown },
  props: {
    stripe: Boolean,
    data: Array,
    pageInfo: {
      type: Object
      // default: () => ({ total: 0, currentPage: 1, pageSize: 20 })
    },
    showLineHeightBox: Boolean,
    lineHeightLevel: {
      type: [Number, String],
      default: 2
    },
    showPointer: Boolean,
    realCount: Boolean
  },
  data() {
    return {
      tableBodyWrapper: null
    }
  },
  computed: {
    rowConfig() {
      let heights = [36, 41, 46]
      return {
        height: heights[this.lineHeightLevel - 1]
      }
    },
    showTotal() {
      return !this.realCount && this.pageInfo.total === 10000 ? "9999+" : this.pageInfo.total
    }
  },
  mounted() {
    this.tableBodyWrapper = this.$el.querySelector(
      ".vxe-table--main-wrapper .vxe-table--body-wrapper"
    )
  },
  methods: {
    pageChange(event) {
      this.$emit("page-change", event)
      this.tableBodyWrapper.scrollTop = 0
    },
    sizeChange(val) {
      this.$emit("size-change", val)
      this.tableBodyWrapper.scrollTop = 0
    },
    refreshColumn() {
      this.$nextTick(() => this.$refs.table.refreshColumn())
    },
    setLineHeightLevel(level) {
      this.$emit("update:lineHeightLevel", level)
      this.$refs.levelDropdown.close()
    },
    reloadTreeExpand(row) {
      this.$refs.table.reloadTreeExpand(row)
    },
    getRealTotal() {
      if (this.showTotal === "9999+") {
        this.$emit("get-real-total")
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.base-table {
  display: flex;
  flex-flow: column;
  .table-wrapper {
    flex: 1;
    height: 0;
  }
  .pagination-wrapper {
    display: flex;
    align-items: center;
    border-left: 1px solid #eaecf0;
    .table-pagination {
      padding: 10px 10px 10px 17px;
      ::v-deep .el-pagination__sizes {
        margin-left: 10px;
        margin-right: 0;
      }
      ::v-deep {
        .el-select .el-input {
          margin: 0 !important;
        }
        .el-input .el-input__inner {
          height: 28px;
          line-height: 28px;
        }
        .el-input .el-input__suffix .el-input__icon {
          line-height: 28px;
        }
      }
    }
    .total {
      color: #606266;
      font-size: 13px;
      margin-right: 27px;
    }
    .svg-icon {
      font-size: 18px;
    }
  }
  ::v-deep {
    .ps__rail-x,
    .ps__rail-y {
      z-index: 10;
    }
    .cursor-pointer {
      .vxe-body--row {
        cursor: pointer;
      }
    }
    .vxe-table--body-wrapper {
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      -ms-overflow-style: none; /* IE 10+ */
      scrollbar-width: none; /* Firefox */
    }
    .vxe-table--body-wrapper {
      font-size: 13px;
      .vxe-tree--btn-wrapper {
        font-size: 12px; //树形加载按钮
      }
    }
  }
}
.command-wrap {
  &.is-active {
    background: $color-bg-select;
  }
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  .svg-icon {
    font-size: 18px;
    margin-right: 8px;
  }
}
</style>
